import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import Paginate from 'vuejs-paginate'

export default {
  name: 'employee-master',
  components: {
    BasicSelect,
    ModelSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data: function() {
		return {
      empname: '',
			salary: '',
			age: '',
			address: '',
      activeStatus: false,
      department: '',	
      roleType: '',		
      employeeNameList:[],
      empStatusSearch: false,
			resultCount: 0,
			isLoading: false,
      checkedType: '',
			useremail: '',
			ageTypeObjData: {
				id: "",
				text: ""
			},
			ageList: [
      {	id: '0',text: " "},
      { id: '18',text: "18"},
      { id: '19',text: "19"},
      { id: '20',text: "20"},
      { id: '21',text: "21"},
      { id: '22',text: "22"},
      { id: '23',text: "23"},
      { id: '24',text: "24"},
      { id: '25',text: "25"},
      { id: '26',text: "26"},
      { id: '27',text: "27"},
      { id: '28',text: "28"},
      { id: '29',text: "29"},
      { id: '30',text: "30"},
      { id: '31',text: "31"},
      { id: '32',text: "32"},
      { id: '33',text: "33"},
      { id: '34',text: "34"},
      { id: '35',text: "35"},
      { id: '36',text: "36"},
      { id: '37',text: "37"},
      { id: '38',text: "38"},
      { id: '39',text: "39"},
      { id: '40',text: "40"},
      { id: '41',text: "41"},
      { id: '42',text: "42"},
      { id: '43',text: "43"},
      { id: '44',text: "44"},
      { id: '45',text: "45"},
      { id: '46',text: "46"},
      { id: '47',text: "47"},
      { id: '48',text: "48"},
      { id: '49',text: "49"},
      { id: '50',text: "50"},
      { id: '51',text: "51"},
      { id: '52',text: "52"},
      { id: '53',text: "53"},
      { id: '54',text: "54"},
      { id: '55',text: "55"},
      { id: '56',text: "56"},
      { id: '57',text: "57"},
      { id: '58',text: "58"},
      { id: '59',text: "59"},
      { id: '60',text: "60"},
      { id: '61',text: "61"},
      { id: '62',text: "62"},
      { id: '63',text: "63"},
      { id: '64',text: "64"},
      { id: '65',text: "65"}
    	],
      searchFlag: false,
      employeeList: [],
      limit: 5,
			pageNo: 0,
			totalRows: 0,
      employeeStatusUpdate: false,
      employeeNameObjData: {
				value: '0',
				text: "Select Employee Name"
			},
      employeeNameSearch: '',
      employeeSearch: '',
      isRoleTypeError: false,
      roletypeerrors: ''
		}
	},

	created: function() {},
	computed: {},
 
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;

    this.getAllEmployeeNameList();
       
  },

  methods: {
		changeRoleType() {
			if (this.checkedType == "On Role") {
				this.roleType ="On Role";
			} else {
				this.roleType ="Off Role";
			}
		},

    selectedEmployeeNameSearch(employeeNameData){
			this.employeeNameObjData = employeeNameData;
      this.employeeSearch = employeeNameData.value;
			this.employeeNameSearch = employeeNameData.text;
    },

    getAllEmployeeNameList() {
      this.isLoading = true;
      var i = 0;
      this.input = ({})
      axios({
        method: 'Get',
        'url': apiUrl.api_url_hubops + 'getAllEmployeeNames',
        'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false;
					  const slist = result.data.ResultData;
            this.employeeNameList.push({value: '0', text: "Select Employee Name"});
					for (i = 0; i < slist.length; i++) {
						this.employeeNameList.push({
							value: slist[i].empno,
							text: slist[i].empname
						})
					}          
          }, error => {
            this.isLoading = false;
            console.error(error)
          })
      },  

      selectedAge(ageData) {
        this.ageTypeObjData = ageData;
        this.age = ageData.text;
        this.ageTypeObjData.id = ageData.id;        
      },

      saveEmployeeData() {
        this.department = '';
        var checkboxes = document.getElementsByName("checkedDept");
        for(var i = 0; i < checkboxes.length; i++)  
        {  
            if(checkboxes[i].checked)  
              this.department = this.department+','+checkboxes[i].value;
        }
        this.isLoading = true;
        this.input = ({
          empname: this.empname,
          salary: this.salary,
          emptype: this.checkedType,
          age: this.age,
          address: this.address,
          status: this.activeStatus,
          department: this.department.substring(1),
          createdby: this.useremail
        })
        
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'insertEmployeeDetails',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
        .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              this.$alert('Employee record inserted Successfully', "", "success");
            }
            else {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            //this.resetForm();
          }, error => {
            this.isLoading = false;
            console.error(error)
          })				
			},

      resetForm() {
        this.empname = '';
        this.salary = '';
        this.age = '0';
        this.address = '';
        this.emptype = '';
        this.department = '';
        this.activeStatus = '';
        this.checkedType = '';
        this.employeeSearch = '';
        this.roleType = '';
        this.empStatusSearch = '';
        this.isRoleTypeError = false;
				this.roletypeerrors = '';
        this.ageTypeObjData = {
          id: "",
				  text: ""
        };
        this.$validator.reset();
        var checkboxes = document.getElementsByName("checkedDept");
        for(var i = 0; i < checkboxes.length; i++)  
        {  
            checkboxes[i].checked = false;
        }
      },

      onSubmit: function() {
        this.isRoleTypeError=false;
				this.roletypeerrors="";
        var self = this
        this.$validator.validateAll('form-1').then((result) => {
          if (this.checkedType.length == 0) {
						this.isRoleTypeError=true;
						this.roletypeerrors="Select Role Type";
            return false;
          } else if (!result) {
            return false;
          } else {
            this.saveEmployeeData();
          }
        }).catch(() => {
          console.log('errors exist')
        });
      },

      getPaginationData(pageNum) {
        this.pageNo = (pageNum - 1) * 5;
        this.getEmployeeDetails();
      },

      getEmployeeDetails() {          
        this.totalRows = 0
        this.resultCount = 0;
        this.searchFlag = true;
        this.employeeList = [];
        this.input = ({})
        let employeeName = this.employeeNameObjData.text;        
        axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'fetchEmployeeDetails?' + '&empname='+ this.employeeName  + '&empstatus=' + this.empStatusSearch + '&limit=' + this.limit + '&offset=' + this.pageNo,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.employeeList = result.data.ResultData;
            this.resultCount = result.data.ResultData.length;
            if (this.resultCount < 5) {
              this.pageNo = 0
            } else {
              this.pageNo = Math.ceil(this.resultCount / 5);
            }
          } else {
            this.employeeList = 0
            this.resultCount = 0
            this.pageNo = 0
          }
        }, error => {
          console.error(error)
        })
    },

    getEmployeeRowData(data) {
      this.employeeStatusUpdate = true;
      this.empno = data.empno;
      this.status = data.status;
      this.empname = data.empname;
      this.address = data.address;
      this.salary = data.salary;
      this.emptype = data.emptype;
      this.department = data.department;
      this.age = data.age;
      if (data.status == true) {
        this.changestatus = 'De-Activate'
      } else {
        this.changestatus = 'Activate'
      }
    },

    closeEmployeeStatusUpdate() {
      this.employeeStatusUpdate = false
    },

    onSubmitSearch: function() {
      this.$validator.validateAll('form-2').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getEmployeeDetails();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },

    changeEmployeeStatus() {
			this.isLoading = true;
			if (this.changestatus == 'De-Activate') {
				var newStatus = false;
			} else {
				var newStatus = true;
			}
			this.input = ({
				empno: this.empno,
				empstatus: newStatus,
				modifiedBy: this.useremail,
			})

			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'updateEmployeeStatusDetails',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.$alert('Employee Status Changed Successfully', "", "success");
					}
					else {
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					this.employeeStatusUpdate = false;
					this.getEmployeeDetails();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
  }
}


// WEBPACK FOOTER //
// ./src/views/components/EmployeeMaster/EmployeeMaster.js